var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThirdLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 788,
    height: 364,
    viewBox: "0 0 788 364",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_2959_996",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.475916 183.447C49.582 121.099 118.608 70.7292 198.826 38.7075C279.043 6.68585 366.849 -5.54955 451.14 3.54859C535.431 12.6467 612.42 42.6698 672.373 89.8211C732.326 136.972 772.549 199.134 787.957 268.446L358.929 363.815L0.475916 183.447Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.475916 183.447C49.582 121.099 118.608 70.7292 198.826 38.7075C279.043 6.68585 366.849 -5.54955 451.14 3.54859C535.431 12.6467 612.42 42.6698 672.373 89.8211C732.326 136.972 772.549 199.134 787.957 268.446L358.929 363.815L0.475916 183.447Z",
    stroke: "#2051A3",
    strokeWidth: 2,
    strokeDasharray: "7 7",
    mask: "url(#path-1-inside-1_2959_996)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThirdLine);
export default __webpack_public_path__ + "static/media/third-line.b28814e9f78e21ed50abfd1bfe1bf6ca.svg";
export { ForwardRef as ReactComponent };